import { CoreFieldProps, fieldTypes, RelativityTooltipV2, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import "./ComplexFields.scss";
import { DepositApplicationReadDTO } from "@/types";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import { Icon, Intent } from "@blueprintjs/core";

export interface RemoteDepositScannerOptInComplexValue {
  showHeader?: boolean;
  headerLabel?: string;
  readOnly?: boolean;
}

export interface RemoteDepositScannerOptInComplexFieldProps extends fieldTypes.BaseFieldProps<any> {
  formValue?: DepositApplicationReadDTO;
}

export const RemoteDepositScannerOptInComplexField: FC<
  RemoteDepositScannerOptInComplexFieldProps
> = (props) => {
  const remoteDepositScannerOptInComplexValue =
    props.complexFieldValue as RemoteDepositScannerOptInComplexValue;
  const readOnly = remoteDepositScannerOptInComplexValue?.readOnly || props.readOnly;

  return (
    <section className="complex-field-container remote-deposit-scanner-opt-in">
      <SectionHeader
        label={remoteDepositScannerOptInComplexValue?.headerLabel || props.label}
        hidden={!remoteDepositScannerOptInComplexValue?.showHeader}
      />
      <div className="complex-field-content">
        <div className="opt-in-v2-switch-container">
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.REMOTE_DEPOSIT_SCANNER_OPT_IN
              .IS_REMOTE_DEPOSIT_SCANNER_OPT_IN_ENABLED
          }
          complexFieldProps={{
            disabled: readOnly,
          }}
        />
          <RelativityTooltipV2 shouldShowTooltip={true} content={"A Remote Deposit Scanner lets you scan checks from your office and deposit them electronically."}>
            <Icon size={15} icon={"info-sign"} intent={Intent.NONE} />
          </RelativityTooltipV2>
        </div>
        {/* Remote Deposit Scanner conditional field - show when enabled */}
        {props.formValue?.remoteDepositScannerOptIn?.isRemoteDepositScannerOptInEnabled && (
          <div className="opt-ins-form-v2__remote-deposit-scanner-fields">
            <FieldComplexV2
              {...props}
              complexFieldKey={COMPLEX_FIELD_KEYS.REMOTE_DEPOSIT_SCANNER_OPT_IN.COMPUTER_TYPE}
              complexFieldProps={
                {
                  disabled: readOnly,
                  showClearButton: true,
                } as Partial<CoreFieldProps>
              }
            />
          </div>
        )}
      </div>
    </section>
  );
};
